import React, { Fragment } from 'react'
import { Table, TableBody, TableCell, TableContainer,TextField,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import DesignationSuffixEditable from './DesignationSuffixEditable';
import DesignationSuffixReadOnly from './DesignationSuffixReadOnly';
import { useEffect } from 'react';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import {useAddNewdesignationsuffixMutation, useGetdesignationsuffixQuery, useUpdatedesignationsuffixMutation, useDeletedesignationsuffixMutation} from '../../../features/designationsuffix/designationSuffixApiSlice';



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Addcategcont =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
`
const Addcategform = styled.form`
  display: flex;
  margin:10px;
`
const FormEleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`
const Displaydiv1 = styled.div`

`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
  margin-top:15px;
`

const AssetCategoryWrapper = styled.div`

`
const Label = styled.label`
    width: 140px;
    margin: 10px;
`

const SuggestSearchWrapper = styled.div`

`

const FormItemdiv = styled.div`

`
const SearchDiv =styled.div`
  position: absolute;
  background-color: white;
  overflow-y: auto;
  height: 400px;
  z-index: 100;
  /* outline: 1px solid black; */
`
const ComplaintCategoryWrapper =styled.div`
  display: flex;

`
const tableFontSize = 18;


function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const {designationsuffix} = useGetdesignationsuffixQuery("desigList", {
    selectFromResult: ({ data }) => ({
      designationsuffix: data?.entities
    }),
  })
  const [addNewDesignationSuffix] = useAddNewdesignationsuffixMutation();
  const [updateDesignationSuffix] = useUpdatedesignationsuffixMutation();
  const [deleteDesignationSuffix] = useDeletedesignationsuffixMutation();

  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({});
  const [addDesgnData, setAddDesgnData] = useState({});
  const [assetCategory, setAssetCategory]=useState([]);
  const [sentData, setSentData ]= useState(0);
  const [subject, setSubject] = useState({
    subjectValue: [...Array(tabledata.length).fill("")],
    subjectIndex: ""
  });

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async (event) =>{
    event.preventDefault();
    try{
      let bodyobject ={"name":addDesgnData.name};
      const found = Object.values(designationsuffix).some(el => el.name === addDesgnData.name);
   if(!found && addDesgnData?.name?.length ){
      const res = await addNewDesignationSuffix(bodyobject) ;
      setAddDesgnData({});
      setSentData(sentData+1);
      }
    } catch(err){console.log(err)}
    setAddDesgnData({})
  }

  const onClickEdit = (e,k,row)=>{
    setEditCategory(k+1);

  }

  const onChangeAddDesgn = (event) =>{
    let temp ={...addDesgnData}
    console.log(temp)
    temp = {...temp, [event.target.name]:event.target.value}
    console.log(temp)
    setAddDesgnData(temp);
  }
  console.log(addDesgnData)

  const onChangeEditDesgn = (event) =>{
    let temp ={...editFormData}    
    temp = {...temp, [event.target.name]:event.target.value}    
    setEditFormData(temp);
  }

  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    try{
    setEditCategory(null);
    const id = tabledata[((page)*(rowsPerPage))+(editCategory-1)].id;
    let body ={}
    if (editFormData[`name${editCategory-1}`] !== undefined){ 
    body = {...body,"id":id, "name":editFormData[`name${((page)*(rowsPerPage))+(editCategory-1)}`] }
    }
    console.log(body)
    const response = await updateDesignationSuffix(body)
    setSentData(body);
    }catch(err){}
  }
  

  const handleCancelClick = (e,k) => {    
    const tempObject = {...subject};
    tempObject.subjectValue[k] = "";
    setEditCategory(null);
    setSubject(tempObject);
  };

  const handleDeleteClick = async (e,k,row) => {
    e.preventDefault();
    let body = {"id":row.id}
    const response = window.confirm(`Do you want to delete designation suffix "${row.name}"` )
    if(!response) return;
    alert(`designation suffix "${row.name}" deleted successfully`);
    const result = await deleteDesignationSuffix(body);
  };    
 

  useEffect(()=>{
    if(designationsuffix){
      const designationsuffixArray = Object.values(designationsuffix);
      setTabledata(designationsuffixArray);
      let temp = {...editFormData};
      for(let i=0;i< designationsuffixArray.length;i++){
        temp = {...temp, [`name${i}`]:designationsuffixArray[i].name}
      }
      setEditFormData(temp);
    }
  },[designationsuffix])

  console.log(editFormData)
   
  return (
    <>
   
    <Displaydiv1>
      <HeadingWrap>
        <Span>Designation Suffix</Span>
      </HeadingWrap>

    <ComplaintCategoryWrapper>
    <Addcategform onSubmit={onSubmit}>
      <FormEleWrapper>
        <TextField
          id="outlined-basic"
          size='small'
          name='name'
          onChange={(event) => onChangeAddDesgn(event)}
          label="Enter a Designation"
          value={addDesgnData.name? addDesgnData.name:""}
          variant="outlined"
          sx={{backgroundColor:"white", width:"200px", height:"40px"}}
        />
        <SubmitButton type='submit'>Submit</SubmitButton>
      </FormEleWrapper> 
  
      </Addcategform>
        </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table" >
      <TableHead>
        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"40%"}}}>Sl.No.</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"40%"}}}>Designation</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}}>Edit</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
              
               <DesignationSuffixEditable row={row} k={key} editFormData={editFormData} subject={subject} 
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage} editCategory={editCategory} SubmitButton ={SubmitButton}
                onChangeEditDesgn={onChangeEditDesgn} assetCategory={assetCategory}
               />

                :<DesignationSuffixReadOnly row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} page={page} rowsPerPage={rowsPerPage} tableFontSize={tableFontSize} SubmitButton ={SubmitButton}                 
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>
    </Displaydiv1>
    </>
  );
}